import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 312px;
  margin-bottom: 0.75rem;
`;

export const IconRight = styled.div`
  text-align: right;
`;
